declare var Highcharts: any;
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import {DashboardService} from "../../../dashboard/services/dashboard.service";
import {merge} from 'lodash';
import {Utils} from '../../Utils';
import { DatePipe} from "@angular/common";

@Component({
  selector: 'app-display-storage-weekly-working',
  templateUrl: './display-storage-weekly-working.component.html'
})
export class DisplayStorageWeeklyWorkingComponent implements OnInit, OnDestroy {

  data: any;
  _chartOptions: any;
  _seriesOptions: any;
  displayChart: boolean = false;
  subscription: any;
  @Input() sourceStorage;
  @Input() title;
  constructor(public dashboardService: DashboardService, public datePipe: DatePipe) { }

  ngOnInit() {
      let that = this;
    this._chartOptions = {
        chart : {
            logo : Highcharts.logos.none,
          height: 350
        },
      title : {
        text : this.title
      },
        credits: {
          enabled: false
        },
      xAxis : {
        type: 'datetime',
           labels: {
             formatter: function(){
               return Utils.dateAsMM(new Date(this.value));
             }
           },
        showFirstLabel : true
      },
      yAxis: {
          title: {
              text: 'billion cubic feet'
          }
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom'
      },
      tooltip: {
        shared: true,
        formatter: function(){
            var formatter = this;

            function checkForData(){
                var toolTipString = '';
                var theDate = that.datePipe.transform(new Date(formatter.x),'MMMM dd', 'UTC'); //Utils.dateAsMMMDD(new Date(formatter.x));

                toolTipString += '<div>' + theDate + '</div><br>';

                formatter.points.forEach(function(element){
                    if(element.series.name.toUpperCase().indexOf('RANGE')>-1){
                        toolTipString += '<div><b>' + element.series.name.toLowerCase() +': </b>'+ Utils.numberWithComma(element.point.low) +  ' to ' + Utils.numberWithComma(element.point.high) + '</div>';
                    }
                    else{
                        toolTipString += '<div><b>'+element.series.name.toLowerCase()+': </b>' + Utils.numberWithComma(element.point.y) + '</div><br>'

                    }
                });
                return toolTipString;
            }
            return checkForData();
        }
      },
      series : []
    };

    this._seriesOptions = {
        'previous' : {
            type : 'line',
            name : null,
            zIndex : 3,
            color: Utils.areaPlotColors.previous,
          xType : Highcharts.xTypes.weekly
        },
      'current' : {
        type : 'line',
        name : null,
        zIndex : 3,
        color:Utils.areaPlotColors.current,
        xType : Highcharts.xTypes.weekly
      },
      'previous_range' : {
        type : 'arearange',
        lineWidth: 0,
        //fillOpacity: 0.3,
        name : null,
        zIndex : 0,
        color : Utils.areaPlotColors.range,
        xType : Highcharts.xTypes.weekly
      },
      'previous_avg' : {
        type : 'line',
        name : null,
        zIndex : 1,
        color : Highcharts.eia_grey,
        xType : Highcharts.xTypes.weekly
      }
    }

    this.subscription = this.dashboardService.getStorageWeeklyWorking(this.sourceStorage).subscribe(
        json=>{
          this.data = json;
        },
        null, //error function
        ()=>{
          this._chartOptions.series = [];

          let current_year = (new Date(this.data[0].data[0][0])).getUTCFullYear();
          this._seriesOptions.previous.name = (current_year -1).toString();
          this._seriesOptions.current.name = current_year.toString();
          this._seriesOptions.previous_range.name = (current_year-5).toString() + '-' + (current_year-1).toString() + ' range';
          this._seriesOptions.previous_avg.name = (current_year-5).toString() + '-' + (current_year-1).toString() + ' average';
          for(let j = 0; j < this.data.length; j++) {
            if(this._seriesOptions[this.data[j].id]) {
              let seriesOptions = merge({}, this._seriesOptions[this.data[j].id]);
              //seriesOptions.legendColor = 'red';

              seriesOptions.data = this.data[j]['data'].sort(function(a,b) {
                return (a[0] < b[0]) ? -1 : ((a[0] > b[0]) ? 1 : 0);
              });
              this._chartOptions.series.push(seriesOptions);
            }
          }

          this.displayChart = true;
    });

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/display-storage-weekly-working/display-storage-weekly-working.component.ts